import { Portal } from '@mui/material'
import React from 'react'

type ToastProps = {
  title: string
}
const Toast = ({ title }: ToastProps) => {
  return (
    <Portal>
      <div
        id="toast-default"
        className="fixed bottom-5 right-2 xs:right-5 flex items-center w-full max-w-[1rem] xs:max-w-xs p-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-0 dark:bg-dark-7 border-gray-8"
        role="alert"
        style={{
          borderWidth: 1,
        }}
      >
        <div className="ms-3 text-sm font-normal">{title}</div>
      </div>
    </Portal>
  )
}

export default Toast
